import { type BasePageParams } from '@/app/urls/url-mapping';
import {
  type AvailableCourseTrack,
  type FullSupportCourseTrack,
  type UrlEntry,
  type UrlRegion,
} from '@/types';

type ApprenticeshipTrack = FullSupportCourseTrack | 'dv';

export type ApprenticeshipPageParams = {
  course: ApprenticeshipTrack;
} & BasePageParams;

export type ApprenticeshipPages = `apprenticeship/${ApprenticeshipTrack}`;

export const urls: Record<
  ApprenticeshipPages,
  Partial<Record<UrlRegion, UrlEntry>>
> = {
  'apprenticeship/cy': {
    fr: 'alternance/cybersecurite',
  },
  'apprenticeship/da': {
    fr: 'alternance/data-analytics',
  },
  'apprenticeship/dv': {
    fr: 'alternance/devops-cloud-computing',
  },
  'apprenticeship/ux': {
    fr: 'alternance/ux-ui-design',
  },
  'apprenticeship/wd': {
    fr: 'alternance/developpement-web',
  },
} satisfies Partial<Record<`apprenticeship/${AvailableCourseTrack}`, unknown>>;
